import * as Yup from 'yup';
import * as R from 'ramda';
import React from 'react';
import { withFormik } from 'formik';
import { pure, compose } from 'react-recompose';
// components
import { FormFooter } from '../../../components/form-footer';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// hocs
import { withAsyncConfigs } from '../../../hocs';
// forms
import { Fieldset2 } from '../../../forms';
//////////////////////////////////////////////////

const inputWrapperStyles = {
  mb: 25,
  width: 350,
};

const getFields = (title) => [
  {
    type: 'select',
    label: [title],
    inputWrapperStyles,
    options: 'declineReasonOptions',
    fieldName: 'statusReasonCodeGuid',
  },
  {
    height: 150,
    type: 'textarea',
    inputWrapperStyles,
    label: ['titles:comments'],
    fieldName: GC.FIELD_COMMENT,
  },
];

const enhance = compose(
  withAsyncConfigs,
  withFormik({
    handleSubmit: (values, { props }) => {
      const { statusReasonCodeGuid } = values;
      const { submitAction, asyncConfigs, statusReasonCodeConfigName } = props;

      const statusReasonCodeDisplayedValue = R.compose(
        R.prop(GC.FIELD_DISPLAYED_VALUE),
        R.find((item) => R.equals(G.getParentGuidOrGuidFromObject(item), statusReasonCodeGuid)),
        R.pathOr([], ['dropdowns', statusReasonCodeConfigName, 'options']),
      )(asyncConfigs);

      submitAction(R.assoc('statusReasonCodeDisplayedValue', statusReasonCodeDisplayedValue, values));
    },
    validationSchema: Yup.object().shape({
      [GC.FIELD_STATUS_REASON_CODE_GUID]: Yup.string().nullable(true).required(G.getRequiredLocaleTxt()),
      [GC.FIELD_COMMENTS]: Yup.string().nullable(true).max(2000, G.getShouldBeFromToCharLocaleTxt(0, 2000)),
    }),
    mapPropsToValues: ({ guid }) => ({
      guid,
      [GC.FIELD_COMMENT]: null,
      [GC.FIELD_STATUS_REASON_CODE_GUID]: null,
    }),
  }),
  pure,
);

const CancelOrDeclineOrderQuoteForm = enhance((props) => (
  <form onSubmit={props.handleSubmit}>
    <Fieldset2
      {...G.getFormikProps(props)}
      fieldsWrapperStyles={{ pt: 10, flexDirection: 'column' }}
      fields={getFields(G.ifElse(
        R.propEq(GC.CLO_QUOTE_CANCEL_REASON_CODE, 'statusReasonCodeConfigName', props),
        'titles:cancel-reason',
        'titles:decline-reason',
      ))}
      declineReasonOptions={G.createOptionsFromDropdownConfigWithGuidOrParentGuid(
        props.asyncConfigs,
        props.statusReasonCodeConfigName,
        true,
      )}
    />
    <FormFooter />
  </form>
));

export default CancelOrDeclineOrderQuoteForm;
